import cisFertigationDataConfig from '@/api/config/cisFertigationDataConfig'
import { queryKeys } from '@/constant/common'
import { useQuery } from '@tanstack/react-query'
import { toast } from 'react-hot-toast'

function useDetailCisFertigation(id: string) {
  return useQuery({
    queryKey: [queryKeys.cisFertigationId, id],
    queryFn: async () => {
      const { data } = await cisFertigationDataConfig.getById(id)
      if (!data) return null
      return data
    },
    onError: (error: any) => {
      toast.error(error?.message)
    },
    enabled: !!id,
  })
}

export default useDetailCisFertigation
